// `__GMAPS_API_KEY__` is a build-time literal injected by rsbuild's source.define
// (see rsbuild.config.ts). Doesn't depend on `process` being polyfilled at runtime.
const buildTimeKey = () => {
	try {
		// eslint-disable-next-line no-undef
		return typeof __GMAPS_API_KEY__ !== 'undefined' ? __GMAPS_API_KEY__ : '';
	} catch {
		return '';
	}
};

const googleApiKeyLookup = () =>
	buildTimeKey() ||
	(typeof import.meta !== 'undefined' &&
		import.meta.env?.REACT_APP_GOOGLE_MAPS_API_KEY) ||
	(typeof import.meta !== 'undefined' &&
		import.meta.env?.PUBLIC_GOOGLE_MAPS_API_KEY) ||
	(typeof process !== 'undefined' && process.env?.PUBLIC_GOOGLE_MAPS_API_KEY) ||
	(typeof process !== 'undefined' && process.env?.REACT_APP_GOOGLE_MAPS_API_KEY) ||
	(typeof window !== 'undefined' && window.REACT_APP_GOOGLE_MAPS_API_KEY) ||
	(typeof localStorage !== 'undefined' && localStorage.getItem('GOOGLE_MAPS_API_KEY')) ||
	'';

export default googleApiKeyLookup;
